import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

import { HeaderNavItem } from './HeaderNavItem';
import pageLogo from './assets/logo.png';
import ProfileDropdown from '../../Common/ProfileDropdown';

export function Header({ profile, profileLoading }) {
	const [isLoggedIn, setIsLoggedIn] = useState(profile !== undefined);
	const [isActive, setIsActive] = useState(false);
	const [rotated, setRotated] = useState(false);

	useEffect(() => {
		if (profile != undefined) {
			setIsLoggedIn(true);
		}
	}, [profile]);

	const handleToggle = () => {
		setIsActive(prevState => !prevState);
		setRotated(!rotated);
	};

	const hamburger1stChild = {
		transform: rotated ? 'rotate(-38deg)' : 'rotate(0deg)',
		transition: 'transform 0.3s ease',
		marginTop: rotated ? '5px' : '0px',
	};
	const hamburger3stChild = {
		transform: rotated ? 'rotate(38deg)' : 'rotate(0deg)',
		transition: 'transform 0.3s ease',
		marginTop: rotated ? '-5px' : '0px',
	};

	return (
		<header className="wp-checkout-header">
			<div className="wp-checkout-row wp-checkout-flex-center ">
				<div className="wp-checkout-col  wp-checkout-col-4">
					<div className="wp-checkout-logo">
						<img
							src={pageLogo}
							alt="Logo"
						/>
					</div>
				</div>
				<div className="wp-checkout-col wp-checkout-col-8">
					<nav
						className={`wp-checkout-nav ${isActive ? 'wp-checkout-active' : ''}`}
					>
						<div className="wp-checkout-flex wp-checkout-flex-center wp-checkout-flex-end wp-checkout-nav-items">
							{/* <HeaderNavItem /> */}

							{profileLoading && (
								<div className="wp-checkout-signIn-btn">
									Loading...
								</div>
							)}

							{!profileLoading &&
								(!isLoggedIn ? (
									<Link
										to={{
											pathname: '/auth/sign-in',
											search: '?redirect=checkout',
											state: { from: '/checkout' },
										}}
										className="wp-checkout-signIn-btn"
									>
										Sign In
									</Link>
								) : (
									<ProfileDropdown />
								))}
						</div>
					</nav>
					<div className=" wp-checkout-flex wp-checkout-hamburger">
						<button
							className="wp-checkout-hamburger-btn"
							onClick={handleToggle}
						>
							<span style={hamburger1stChild}></span>
							<span
								style={
									isActive
										? { display: 'none' }
										: { display: 'block' }
								}
							></span>
							<span style={hamburger3stChild}></span>
						</button>
					</div>
				</div>
			</div>
		</header>
	);
}
